import React from "react";
import styles from "./MessageTime.module.css";
import {formatDateTime} from "../../../../../../../utils/dateTimeUtil";

interface MessageTimeProps {
    timestamp: string
}

export const MessageTime: React.FC<MessageTimeProps> = ({
                                                            timestamp
                                                        }) => {

    const {time} = formatDateTime(timestamp)
    return <span className={styles.wrapper}>
        {time}
    </span>
}
